import Config from 'react-native-config'
import { Apollo, Device } from '@src/config'
import { isProductionEnvironment } from '@src/config/apollo'

export const getDevId = () => {
  if (Device.web) {
    return ''
  }
  const endpointEnv = Apollo.endpointEnv
  if (isProductionEnvironment(endpointEnv)) {
    return Config.TERRA_PRODUCTION_DEV_ID
  } else if (endpointEnv === 'staging') {
    return Config.TERRA_STAGING_DEV_ID
  }

  return Config.TERRA_DEVELOPMENT_DEV_ID
}
